import script from "./LocationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationItem.vue?vue&type=script&setup=true&lang=js"

import "./LocationItem.vue?vue&type=style&index=0&id=0328c48e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0328c48e"]])

export default __exports__